import React, { useEffect } from 'react';
import { Button } from 'react-bootstrap';
import BackButton from '../components/utils/BackButton';
import Toggle from '../components/utils/Toggler';
import { projects } from '../ProjectData';
import { GitHub } from 'react-feather';

export const Projects = ({ theme, toggleTheme }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div id='projects'>
      <BackButton />
      <div id='toggle-projectpg'>
        <Toggle theme={theme} toggleTheme={toggleTheme} />
      </div>
      <div className='container'>
        <h2 className='heading-lg' style={{ paddingTop: '70px' }}>
          all projects
        </h2>
        <div
          className='project-gallery pb-3'
          uk-scrollspy='cls: uk-animation-fade; target: .uk-card; delay: 200; repeat: true'
        >
          {projects.map((project) => (
            <div
              key={project.id}
              className='card uk-card uk-card-hover uk-card-body my-3 proj-card'
            >
              <div className='container d-flex flex-column'>
                <div className='uk-label tech-label align-self-end my-2'>
                  {project.tech.join(', ')}
                </div>
                <div className='uk-text-center proj-content'>
                  <div
                    className='uk-inline-clip uk-transition-toggle'
                    tabindex='0'
                  >
                    <img src={project.img} alt='' />
                    <div className='uk-transition-fade uk-position-cover uk-position-small uk-overlay uk-overlay-default uk-flex uk-flex-center uk-flex-middle'>
                      <p
                        className='uk-margin-remove'
                        style={{ color: 'black' }}
                      >
                        {project.desc}
                      </p>
                    </div>
                  </div>
                </div>
                <h3 className='proj-title '>{project.name}</h3>
                <div className='project-links'>
                  {project.github && (
                    <Button variant='success' className='m-2'>
                      <a href={project.github} target='_blank' rel='noreferrer'>
                        <GitHub />
                      </a>
                    </Button>
                  )}
                  {project.github && (
                    <Button className='m-2'>
                      <a href={project.link} target='_blank' rel='noreferrer'>
                        Live Site
                      </a>
                    </Button>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
